import React from 'react';
import PropTypes from 'prop-types';
import {get} from '../Storage';
import {ClassName, DateTool} from "mgToolsKit";
import { ProgressBar } from "../../../Common/ui";
import { MGSiteButton } from 'mgUiKit';

// Init Configuration
var AppSettings = get();
var componentName = AppSettings.appId + 'WidgetCouponComponent';

class Coupon extends React.Component {
    constructor(props) {
        super(props);
        this.goToPage = this.goToPage.bind(this);
    }

    goToPage(urlCoupon){
        if(urlCoupon != ""){
            location.href = urlCoupon;
        }
    }

    renderLimitazioni(){
        var coupon = this.props.data;
        if(coupon.details == null){
            return "";
        }
        var details = coupon.details;
        var retHtml = [];

        switch(details.betType.toLowerCase()){
            case 'mixed':
                retHtml.push(
                    <li key="betType">Coupon spendibile per gli eventi Live e Prematch</li>
                );
                    break;
            case "prematch":
            case 'live':
                retHtml.push(
                    <li key="betType">Coupon spendibile per gli eventi {details.betType}</li>
                );
                    break;
        }

        let minOutcomes = parseFloat(details.minOutcomes);
        if(isNaN(minOutcomes)){
            minOutcomes = 0;
        }
        
        let maxOutcomes = parseFloat(details.maxOutcomes);
        if(isNaN(maxOutcomes)){
            maxOutcomes = 0;
        }

        if (minOutcomes > 0 || maxOutcomes > 0) {
            if (minOutcomes > 0 && maxOutcomes > 0 && maxOutcomes < 50) {
                if (minOutcomes == 1 && maxOutcomes == 1) {
                    retHtml.push(
                        <li key="outcome">Gioca una singola</li>
                    );
                }
                else {
                    let label = "selezione";
                    if(minOutcomes> 1){
                        label = "selezioni";
                    }
                    retHtml.push(
                        <li key="outcome">Gioca min. <strong> {minOutcomes}</strong> {label} fino a <strong> {maxOutcomes}</strong></li>
                    );
                }
            }
            else {
                if (minOutcomes > 0) {
                    if (minOutcomes == 1) {
                        retHtml.push(
                            <li key="outcome">Gioca una singola</li>
                        );
                    }
                    else {
                        let label = "selezione";
                        if(minOutcomes > 1){
                            label = "selezioni";
                        }
                        retHtml.push(
                            <li key="outcome">Gioca min. <strong>{minOutcomes}</strong> {label}</li>
                        );
                    }
                }
                else {
                    let label = "selezione";
                    if(maxOutcomes > 1){
                        label = "selezioni";
                    }
                    retHtml.push(
                        <li key="outcome">Gioca max. <strong>{maxOutcomes}</strong> {label}</li>
                    );
                }
            }
        }

        // min e max aoutcomes
        let minOddForOutcome = parseFloat(details.minOddForOutcome);
        if(isNaN(minOddForOutcome)){
            minOddForOutcome = 1;
        }
        else{
            minOddForOutcome = minOddForOutcome / 100;            
        }
        
        let maxOddForOutcome = parseFloat(details.maxOddForOutcome);
        if(isNaN(maxOddForOutcome)){
            maxOddForOutcome = 1;
        }
        else{
            maxOddForOutcome = maxOddForOutcome / 100;            
        }

        if (minOddForOutcome > 1 || (maxOddForOutcome > 1 && maxOddForOutcome < 10000)) {
            if (minOddForOutcome > 1 && maxOddForOutcome > 1 && maxOddForOutcome< 10000) {
                retHtml.push(
                    <li key="singleoutcome">Ogni selezione deve avere una quota min. di <strong>{minOddForOutcome}</strong> fino a <strong>{maxOddForOutcome}</strong></li>
                );
            }
            else {
                if (minOddForOutcome > 1) {
                    retHtml.push(
                        <li key="singleoutcome">Ogni selezione deve avere una quota min. <strong>{minOddForOutcome}</strong></li>
                    );
                }
                else {
                    retHtml.push(
                        <li key="singleoutcome">Ogni selezione deve avere una quota max. <strong>{maxOddForOutcome}</strong></li>
                    );
                }
            }
        }

        // Total odds
        let minOddForTotalBet = parseFloat(details.minOddForTotalBet);
        if(isNaN(minOddForTotalBet)){
            minOddForTotalBet = 1;
        }
        else{
            minOddForTotalBet = minOddForTotalBet / 100;
        }
        
        let maxOddForTotalBet = parseFloat(details.maxOddForTotalBet);
        if(isNaN(maxOddForTotalBet)){
            maxOddForTotalBet = 1;
        }
        else{
            maxOddForTotalBet = maxOddForTotalBet / 100;
        }

        if (minOddForTotalBet > 1 || (maxOddForTotalBet> 1 && maxOddForTotalBet < 10000)) {
            if (minOddForTotalBet > 1 && maxOddForTotalBet > 1 && maxOddForTotalBet < 10000) {
                retHtml.push(
                    <li key="totalodds">Quota totale min. di <strong>{minOddForTotalBet}</strong> fino a <strong>{maxOddForTotalBet}</strong></li>
                    );
            }
            else {
                if (minOddForTotalBet > 1) {
                    retHtml.push(
                         <li key="totalodds"> Quota totale min. <strong>{minOddForTotalBet}</strong></li>
                    );
                }
                else {
                    retHtml.push(
                        <li key="totalodds">Quota totale max. <strong>{maxOddForTotalBet}</strong></li>
                    );
                }
            }
        }

        if(retHtml.length == 0){
            return "";
        }
        return(
            <>
                <span className="mg-fb-label">Limitazioni</span>
                <ul className="mg-dati-coupon-moreinfo-details">
                    {retHtml}
                </ul>
            </>
        );
    }

    renderLimitazioniWagering(){
        var coupon = this.props.data;
        if(coupon.wagering == null && coupon.wagering.details == null){
            return "";
        }
        var details = coupon.wagering.details;
        // Le limitazioni le mostriamo solo se il coupon non è SBLOCCATO
        if(coupon.wagering.status != 1){
            return "";
        }
        var retHtml = [];

        var formatEuro = new Intl.NumberFormat('it-IT', {
            style: 'currency',
            currency: 'EUR',
        });


        // Tipo di wagering
        // if(details.type != null && details.type != ""){
        //     retHtml.push(
        //         <li key="type">Tipo di wagering: {details.type}</li>
        //     );
        // }

        switch(details.betType.toLowerCase()){
            case 'mixed':
                retHtml.push(
                    <li key="betType">Concorrono tutti gli eventi Live e Prematch</li>
                );
                    break;
            case "prematch":
            case 'live':
                retHtml.push(
                    <li key="betType">Concorrono solo gli eventi {details.betType}</li>
                );
                break;
        }

        // Criterio di assegnazione
        if(details.assignmentCriterion != null){
            let ac = "";
            switch(details.assignmentCriterion){
                // Per importo
                case 1:
                    ac = "allo spoglio";
                    break;
                    // Per vendita
                case 2:
                    ac = "alla vendita";
                    break;

            }
            if(ac != ""){
                retHtml.push(
                    <li key="assignmentCriterion">Criterio di assegnazione: {ac}</li>
                );
            }
        }

        // Esclude gli antepost
        if(details.assignmentCriterion == 1
            && details.contributionCanceledTickets != null){
                if(details.contributionCanceledTickets){
                    retHtml.push(
                        <li key="contributionCanceledTickets">I ticket annullati contribuiscono al calcolo</li>
                    );
                }
                else{
                    retHtml.push(
                        <li key="contributionCanceledTickets">I ticket annullati non contribuiscono al calcolo</li>
                    );
                }
            
       }
  
        // Importo massimo giocabile
        let wageringCAP = parseFloat(details.wageringCAP);
        if(!isNaN(wageringCAP) && wageringCAP > 0){
            retHtml.push(
                <li key="wageringCAP">Importo massimo giocabile: {formatEuro.format(wageringCAP)}</li>
            );
        }

        // min e max numero esiti
        let minOutcomes = parseFloat(details.outcomeFrom);
        if(isNaN(minOutcomes)){
            minOutcomes = 0;
        }
        
        let maxOutcomes = parseFloat(details.outcomeTo);
        if(isNaN(maxOutcomes)){
            maxOutcomes = 0;
        }

        if (minOutcomes > 0 || maxOutcomes > 0) {
            if (minOutcomes > 0 && maxOutcomes > 0 && maxOutcomes < 50) {
                if (minOutcomes == 1 && maxOutcomes == 1) {
                    retHtml.push(
                        <li key="outcome">Gioca una singola</li>
                    );
                }
                else {
                    let label = "selezione";
                    if(minOutcomes > 1){
                        label = "selezioni";
                    }
                    retHtml.push(
                        <li key="outcome">Gioca min. <strong> {minOutcomes}</strong> {label} fino a <strong> {maxOutcomes}</strong></li>
                    );
                }
            }
            else {
                if (minOutcomes > 0) {
                    if (minOutcomes == 1) {
                        retHtml.push(
                            <li key="outcome">Gioca una singola</li>
                        );
                    }
                    else {
                        let label = "selezione";
                        if(minOutcomes > 1){
                            label = "selezioni";
                        }
                        retHtml.push(
                            <li key="outcome">Gioca min. <strong>{minOutcomes}</strong> {label}</li>
                        );
                    }
                }
                else {
                    let label = "selezione";
                    if(maxOutcomes > 1){
                        label = "selezioni";
                    }
                    retHtml.push(
                        <li key="outcome">Gioca max. <strong>{maxOutcomes}</strong> {label}</li>
                    );
                }
            }
        }

        // min e max odds
        let minOddForOutcome = parseFloat(details.oddFrom);
        if(isNaN(minOddForOutcome)){
            minOddForOutcome = 1;
        }
        
        let maxOddForOutcome = parseFloat(details.oddTo);
        if(isNaN(maxOddForOutcome)){
            maxOddForOutcome = 1;
        }

        if (minOddForOutcome > 1 || (maxOddForOutcome > 1 && maxOddForOutcome < 10000)) {
            if (minOddForOutcome > 1 && maxOddForOutcome > 1 && maxOddForOutcome< 10000) {
                retHtml.push(
                    <li key="singleoutcome">Ogni selezione deve avere una quota min. di <strong>{minOddForOutcome}</strong> fino a <strong>{maxOddForOutcome}</strong></li>
                );
            }
            else {
                if (minOddForOutcome > 1) {
                    retHtml.push(
                        <li key="singleoutcome">Ogni selezione deve avere una quota min. <strong>{minOddForOutcome}</strong></li>
                    );
                }
                else {
                    retHtml.push(
                        <li key="singleoutcome">Ogni selezione deve avere una quota max. <strong>{maxOddForOutcome}</strong></li>
                    );
                }
            }
        }

        // Total odds
        let minOddForTotalBet = parseFloat(details.oddTicketFrom);
        if(isNaN(minOddForTotalBet)){
            minOddForTotalBet = 1;
        }
        
        let maxOddForTotalBet = parseFloat(details.oddTicketTo);
        if(isNaN(maxOddForTotalBet)){
            maxOddForTotalBet = 1;
        }
        if (minOddForTotalBet > 1 || (maxOddForTotalBet> 1 && maxOddForTotalBet < 10000)) {
            if (minOddForTotalBet > 1 && maxOddForTotalBet > 1 && maxOddForTotalBet < 10000) {
                retHtml.push(
                    <li key="totalodds">Quota totale min. di <strong>{minOddForTotalBet}</strong> fino a <strong>{maxOddForTotalBet}</strong></li>
                    );
            }
            else {
                if (minOddForTotalBet > 1) {
                    retHtml.push(
                         <li key="totalodds"> Quota totale min. <strong>{minOddForTotalBet}</strong></li>
                    );
                }
                else {
                    retHtml.push(
                        <li key="totalodds">Quota totale max. <strong>{maxOddForTotalBet}</strong></li>
                    );
                }
            }
        }

        // Esclude gli antepost
         if(details.discardAntepost != null && details.discardAntepost){
             retHtml.push(
                 <li key="discardAntepost">Non applicabile agli antepost</li>
             );
        }

        // Esclude i marcatori
        if(details.discardScorer != null && details.discardScorer){
            retHtml.push(
                <li key="discardScorer">Non applicabile ai marcatori</li>
            );
        }

        if(details.groupId != null && details.groupId > 0){
            retHtml.push(
                <li key="groupId">Applicabile ad numero di limitato di scommesse [{details.groupId}]</li>
            );
        }

        if(retHtml.length == 0){
            return "";
        }
        return(
            <>
                <span className="mg-fb-label">Regole per lo sblocco del coupon</span>
                <ul className="mg-dati-coupon-moreinfo-details">
                    {retHtml}
                </ul>
            </>
        );
    }

    renderInfoAggiuntive(){
        var coupon = this.props.data;
        var id  = "info-dettagli-" + coupon.key;
        let limitazioni = null;

        if(coupon.wagering != null && coupon.wagering.status == 1){
            limitazioni = this.renderLimitazioniWagering();
        }
        else{
            limitazioni = this.renderLimitazioni();
        }
        if(limitazioni == null || limitazioni == ""){
            return "";
        }

        //var from = new DateTool(coupon.validFrom).getDate();
        //var to = new DateTool(coupon.validTo).getDate();
        return (
            <div className="mg-dati-coupon-moreinfo">
                <input type="checkbox" id={id} className="toggle-info" />
                <label htmlFor={id} className="toggle-label">Informazioni e dettagli</label>
                <div className="mg-dati-coupon-moreinfo-opened">
                    {/* <p className="mg-long-description">
                        {coupon.description}
                    </p> */}
                    {limitazioni}                
                </div>
            </div>
        );
    }

    renderProgressBar(){
        var coupon = this.props.data
        if(coupon.wagering == null || coupon.wagering.status != 1){
            return "";
        }
        let _percent = 0;
        if(coupon.wagering.amount > 0 && coupon.wagering.totalAmount > 0){
            _percent = (100 * coupon.wagering.amount) / coupon.wagering.totalAmount;
            if(_percent > 100){
                _percent = 100;
            }
        }
        return (
            <span className="mg-bonus-data">
                <ProgressBar percentage={parseInt(_percent)} />
            </span>
        );
    }

    render() {
        var formatEuro = new Intl.NumberFormat('it-IT', {
            style: 'currency',
            currency: 'EUR',
        });

        let State = {    
            "1": "In corso",            
            "2": "Attivo"
        };
        let _couponBlocked = false;

        var coupon = this.props.data
        var _className  = new Array();
        _className.push("mg-user-widget");
        var serviceCode = coupon.serviceCode.toLowerCase();
        _className.push("mg-bonus-" + serviceCode);
        
        if(coupon.wagering != null){
            _className.push("mg-coupon-wagering");
            // Il coupon non è ancora attivo
            if(coupon.wagering.status == 1){
                _couponBlocked  = true;
                
            }
        }

        if(_couponBlocked){
            _className.push("mg-coupon-blocked");
        }

        // Gestione url coupon
        var urlCoupon = coupon.url;
        switch(serviceCode){
            case "pgad": 
                urlCoupon = "";
            break;
            case "casino":
                if(AppSettings.couponurl.casino != ""){
                    urlCoupon = AppSettings.couponurl.casino;
                }
                break;
            case "casinolive":    
                if(AppSettings.couponurl.casinolive != ""){
                    urlCoupon = AppSettings.couponurl.casinolive;
                }
                break;
            case "poker":    
                if(AppSettings.couponurl.poker != ""){
                    urlCoupon = AppSettings.couponurl.poker;
                }
                break;
                
            // Generico
            case "cardgames":  
                if(AppSettings.couponurl.cardgames != ""){
                    urlCoupon = AppSettings.couponurl.cardgames;
                } 
                break;
            // case "lotto":
            //     if(AppSettings.couponurl.lotto != ""){
            //         urlCoupon = AppSettings.couponurl.lotto;
            //     } 
            //     break;

            /*case "skillgames":    
                couponContainer = '<a href="#" class="mg-play-game"><span>'+coupon.amount +'</span></a>';
                break;*/
        }

        let couponExpire = coupon.expire; 
        let timeExpire = coupon.timeExpire;
        let promoUrl = "";
        let promoDescription = "";
        if(coupon.wagering != null && coupon.wagering.expire != null){
            if(coupon.wagering.status == 1){
                couponExpire = new DateTool(coupon.wagering.expire).getDate();
                timeExpire = new DateTool(coupon.wagering.expire).getTime();
                if(coupon.wagering.details != null){
                    let details = coupon.wagering.details;
                    let promoInfo = details.promoInfo;
                    if(typeof promoInfo == 'string' && promoInfo.length > 0){
                        if(promoInfo.indexOf("http://") != -1
                            || promoInfo.indexOf("https://") != -1){
                            promoUrl = promoInfo;
                        }
                        else{
                            promoDescription =  promoInfo;
                        }
                    }
                }
            }     
        }
        let hrefAttribute = urlCoupon != "" ? { href:urlCoupon } : {};
        let couponHtml = <>
            <i className="fa fa-gift"></i>
            <div className="mg-bonus-wrap">
                <a className="mg-play-game" {...hrefAttribute}>
                    <span className="mg-user-widget-titolo">
                        {coupon.description}
                    </span>
                </a>
                {coupon.expire != "" ?
                    <span className="mg-bonus-data">Valido fino al <strong>{couponExpire} {timeExpire}</strong></span>
                : ""}
                {coupon.wagering != null ?
                <>
                  {this.renderProgressBar()}
                  {coupon.wagering.status == 1?
                    <span className="mg-bonus-data">Spendi <strong>{formatEuro.format(coupon.wagering.totalAmount)}</strong> per sbloccare il coupon</span>
                  :""}
                  {/* <span className="mg-bonus-data">Stato <strong>{State[coupon.wagering.status]}</strong></span> */}
                 </>
                : ""}
            </div>
            <span className="mg-bonus-importo--valore">
                {coupon.amount}
            </span>
            
        </>;

        return (
            <div className={ClassName(_className)}>
                <div className="mg-dati-ecoupon" onClick={this.goToPage.bind(this,urlCoupon)}>
                    {couponHtml}
                </div>
                {(promoUrl != "") ?
                    <MGSiteButton  
                        label="Vai alla promozione"
                        title="Vai alla promozione"
                        disabled={false}
                        primary={true}
                        isButton={true}
                        fullWidth={true}                        
                        href={promoUrl}
                        className="mg-link-promotion"
                    />                 
                    : ""}

                  {(promoDescription != "") ?
                       <p className="promo-description">{promoDescription}</p>
                    : ""}   

                {this.renderInfoAggiuntive()}
                
            </div>
        );
    }
}

Coupon.displayName = componentName;

// PropTypes validation
Coupon.propTypes = {
    data: PropTypes.object.isRequired
};

// default props
Coupon.defaultProps = {
};

export default Coupon;